<div class="blank-page-container">
	<pcp-cmdb-search-gadget></pcp-cmdb-search-gadget>
</div>
